// src/App.tsx
import { HashRouter as Router, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { theme as customTheme } from './theme';
import { SnackbarProvider } from './Components/Stateless/SnackBarProvider';
import { HimmaProvider } from './Components/HimmaProvider';
import { PermissionProvider } from './context/PermissionContext';
import { NotificationProvider } from './context/NotificationContext';
import PublicRoutes from './Routes/PublicRoutes';
import ProtectedRoutes from './Routes/ProtectedRoutes';

const App = () => {
  const { i18n } = useTranslation();
  const theme = createTheme({
    ...customTheme,
    direction: i18n.language === 'ar' ? 'rtl' : 'ltr',
  });

  return (
    <ThemeProvider theme={theme}>
      <HimmaProvider baseUrl={import.meta.env.VITE_BASE_URL}>
        <PermissionProvider>
          <NotificationProvider>
            <SnackbarProvider>
              <Router>
                <Routes>
                  {PublicRoutes()}
                  {ProtectedRoutes()}
                </Routes>
              </Router>
            </SnackbarProvider>
          </NotificationProvider>
        </PermissionProvider>
      </HimmaProvider>
    </ThemeProvider>
  );
};

export default App;
